enum QuestionTypeEnum {
  Text = 858070000,
  YesNo = 858070001,
  Slider = 858070002,
  MultipleChoice = 858070003,
  Date = 858070004,
}
export default QuestionTypeEnum;
